// var path = location.pathname;
// var list_path = path.split('/');

// if (list_path[1] == 'en') {
//   $('#header_' + list_path[2]).addClass('is-selected');
//   // if (list_path[2].length) {
//   // }
// } else if (list_path[1].length) {
//   $('#header_' + list_path[1]).addClass('is-selected');
// }



$(function(){
	$('[id^=set_lang_]').on('click', function(){
		var langPath = this.hreflang // ['/', '/en/', '/ch/', '/ko/']
		var lang = langPath.replace(/\//g, '') || 'ja' // ['ja', 'en', 'ch', 'ko']
		var setUrl = $('[data-' + lang + '-url]').data(lang + '-url')
		var href = ''

		try {
			// URL設定がある場合
			if (setUrl !== undefined) {
				// 設定はあるのに空値の場合
				if (! setUrl) {
					// この言語のページは存在しないので例外で処理する
					throw('Set url is not found.')
				}
				href = setUrl
			}
			else {
				var path = langPath + location.pathname.replace(/^\/(en)\//, '')
				href = path.replace('\/\/', '/') + location.search
			}
		} catch (e) {
			// 設定があるのに空値だった場合、行き先がないのでその言語のトップへ飛ばす
			href = langPath
		}

		window.location.href = href

	})
})

var $lang = $("html").attr("lang");
var rep = "";
var $langRep = function(v) {
  return $lang;
}

$(".l-header-nav__sub__nav__item__lang").each(function(i, v) {
  var $href = $(this).find("a").attr("id");
  if($href.match($langRep($lang)) || $href == "/") {
    var $langText = $(this).find(".l-header-nav__sub__nav__item__lang__text").text();
    $(this).addClass("is-current");
    const limit = localStorage.getItem("languageLimit") || 0;
    const current = new Date().getTime();
  }
})
